module.exports = __webpack_public_path__ + "static/media/down_arrow.2885ee93.png";